import React from 'react';
import './table.scss';
import { EyeIcon, FileText } from 'lucide-react';
import moment from 'moment';
import { Link } from 'react-router-dom';

const RecentReports = () => {
    let recentVisit = localStorage.getItem('recentReport');
    let reports = JSON.parse(recentVisit);

    return (
        <div className="recentListContainer">
            <table className="recentListTable">
                <thead>
                    <tr>
                        <th>Report Name</th>
                        <th>Category</th>
                        <th>Last Viewed</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {reports && reports.length > 0 ? (
                        reports.map((report, index) => (
                            <tr key={index}>
                                <td className="recentListName">
                                    <FileText />
                                    <p style={{ color: 'black' }}>{report.fileName}</p>
                                </td>
                                <td>{report.categoryName}</td>
                                <td>{moment(report.time).format('DD-MM-YYYY')}</td>
                                <td>
                                    <Link to={`/dashboard/reports?categoryName=${report.categoryName}`}>
                                        <span>
                                            <EyeIcon />
                                        </span>
                                    </Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                                <p>No recent report data found.</p>
                                <Link to="/dashboard/category/list">
                                    <button className="goToCategoryBtn">Go to Category Page</button>
                                </Link>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default RecentReports;
